import * as yup from 'yup';

export const MCNDeductionInputs = {
    ASSIGNED_EMPLOYEE: "assigned_employee",
    DESCRIPTION: "description",
    EFFECTIVE_START: "effective_start",
    EFFECTIVE_END: "effective_end",
    AMOUNT: "amount",
    PERCENT: "percent",
    ANNUAL_LIMIT_AMOUNT: "annual_limit_amount",
    TOTAL_LIMIT_AMOUNT: "total_limit_amount",
}

export const mcnDeductionSchema = yup.object({
    [MCNDeductionInputs.ASSIGNED_EMPLOYEE]: yup.string().required('Employee is required'),
    [MCNDeductionInputs.DESCRIPTION]: yup.string().required('Description is required'),
    [MCNDeductionInputs.EFFECTIVE_START]: yup.string().nullable().default(''),
    [MCNDeductionInputs.EFFECTIVE_END]: yup.string().nullable().default(''),
    [MCNDeductionInputs.AMOUNT]: yup.string().nullable().default(''),
    [MCNDeductionInputs.PERCENT]: yup.string().nullable().default(''),
    [MCNDeductionInputs.ANNUAL_LIMIT_AMOUNT]: yup.string().nullable().default(''),
    [MCNDeductionInputs.TOTAL_LIMIT_AMOUNT]: yup.string().nullable().default(''),
});

export const ChildSupportDeductionInputs = {
    ASSIGNED_EMPLOYEE: "assigned_employee",
    DESCRIPTION: "description",
    EFFECTIVE_START: "effective_start",
    EFFECTIVE_END: "effective_end",
    AMOUNT: "amount",
    MAX_PERCENT: "max_percent",
    EXTERNAL_ID: "external_id",
    FIPS_CODE: "fips_code",
    ISSUING_STATE: "issuing_state",
    ISSUE_DATE: "issue_date",
    IS_MANAGED: "is_managed",
}

export const childSupportDeductionSchema = yup.object({
    [ChildSupportDeductionInputs.ASSIGNED_EMPLOYEE]: yup.string().required('Employee is required'),
    [ChildSupportDeductionInputs.DESCRIPTION]: yup.string().nullable().default(''),
    [ChildSupportDeductionInputs.EFFECTIVE_START]: yup.string().nullable().default(''),
    [ChildSupportDeductionInputs.EFFECTIVE_END]: yup.string().nullable().default(''),
    [ChildSupportDeductionInputs.AMOUNT]: yup.string().required('Amount is required'),
    [ChildSupportDeductionInputs.MAX_PERCENT]: yup.string().nullable().default(''),
    [ChildSupportDeductionInputs.EXTERNAL_ID]: yup.string().nullable().default(''),
    [ChildSupportDeductionInputs.FIPS_CODE]: yup.string().nullable().default(''),
    [ChildSupportDeductionInputs.ISSUING_STATE]: yup.string().nullable().default(''),
    [ChildSupportDeductionInputs.ISSUE_DATE]: yup.string().nullable().default(''),
    [ChildSupportDeductionInputs.IS_MANAGED]: yup.boolean().default(false),
});
